import { render, staticRenderFns } from "./file-preview.vue?vue&type=template&id=94e285f2&scoped=true&"
import script from "./file-preview.vue?vue&type=script&lang=js&"
export * from "./file-preview.vue?vue&type=script&lang=js&"
import style0 from "./file-preview.vue?vue&type=style&index=0&id=94e285f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94e285f2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('94e285f2')) {
      api.createRecord('94e285f2', component.options)
    } else {
      api.reload('94e285f2', component.options)
    }
    module.hot.accept("./file-preview.vue?vue&type=template&id=94e285f2&scoped=true&", function () {
      api.rerender('94e285f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/file-preview.vue"
export default component.exports